module.exports = __webpack_public_path__ + "media/images/new_home/9-jeff-lindor-8fadd3d68095bc4b6e2bc1f0f16321fd.png";